import { useState } from 'react';

const usePagination = (totalPages, initialPage = 1) => {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [inputValue, setInputValue] = useState(initialPage);

  const goToPage = (page) => {
    const pageNumber = Math.max(1, Math.min(totalPages, Number(page)));
    setCurrentPage(pageNumber);
    setInputValue(pageNumber);
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      goToPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      goToPage(currentPage - 1);
    }
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputSubmit = (e) => {
    e.preventDefault();
    goToPage(inputValue);
  };

  return { currentPage, inputValue, goToPage, nextPage, prevPage, handleInputChange, handleInputSubmit };
};

export default usePagination;
